import * as APIRoutes from '@mm/api-routes';
import AuthenticatedController from './AuthenticatedController';
import { GuidesPayload } from '../model/GuidesModel';

export class GuidesController extends AuthenticatedController {
  static async getAll(): Promise<GuidesPayload> {
    return super.get(APIRoutes.GUIDES);
  }
}
